export default __webpack_public_path__ + "static/media/Ntorq125FI_LateralDer.eec40ff3.webp";